/**
 * Created: 2026-09-25
 * Initial commit: Move getWeekdayText to shared package
 *
 * Shared date utility for getting Chinese weekday text.
 */

/**
 * Get weekday text in Chinese format (周一, 周二, etc.)
 * Accepts a Date or a date string in YYYY-MM-DD format.
 */
export function getWeekdayText(date: Date | string): string {
  const d =
    typeof date === 'string'
      ? new Date(`${date}T00:00:00`) // force local time parsing
      : date
  const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  return weekdays[d.getDay()]
}
